import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";
import { FormField } from "../../../../sharedComponents/formField";
import { NotificationManager } from "react-notifications";

import { declineFood } from "../../../../store/actions/index";
import { PanelBody, PanelFooter } from "../../../../sharedComponents/filterPanel";
import { required } from "../../../../constants/formValidators";
import { declineCodes } from "../../../../constants/recipeConstants";

const DeclineFoodPanel = ({ data, handleSubmit, declineFood, onUpdate, history, onError, resetForm }) => {
	const validateForm = (values) => {
		const successHandler = () => {
			NotificationManager.success("Food declined!", "", 5000);
			onUpdate();
			resetForm("DeclineFoodPanel");
			history.push(`/nutrition/food-database/approval`);
		};
		const errorHandler = () => {
			NotificationManager.error("Food not declined! Please try again.", "", 5000);
			onError();
		};
		declineFood({ ...values, id: data }, successHandler, errorHandler);
	};

	return (
		<form className="advanced-filter-form" onSubmit={handleSubmit(validateForm)}>
			<PanelBody>
				<div className="row">
					<div className="col-12">
						<Field
							label="Decline code"
							name="decline_code"
							type="select"
							options={declineCodes}
							component={FormField}
							validate={[required]}
						/>
					</div>
				</div>
			</PanelBody>
			<PanelFooter className="pt-0">
				<div className="text-right pt-3">
					<button className="btn btn-primary-dark text-uppercase" type="submit">
						Decline
					</button>
				</div>
			</PanelFooter>
		</form>
	);
};

const mapDispatchToProps = {
	declineFood,
	resetForm: reset,
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "DeclineFoodPanel",
		enableReinitialize: true,
	})(DeclineFoodPanel)
);
